/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  gs,
  ls,
  a,
  BoxC,
  BtnC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';
import * as icm from './icm';

import * as icvBaseD10Rz from './icvBaseD10Rz';
//import Iccv12ap from './Iccv12ap';
//import Iccv12as from './Iccv12as';

export const N = () => {

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  const _sPz = ls.usePagez({
    steps: [0],
  });

//hf.l(`icvHomeS10Rz 37: ${_gUserz.crt._31rz?._fst}`);
  icm.loadAtTopAsync({
//    _31r_fst: _gUserz.crt._31rz?._fst,
    _31r_fst: 0,
    frcUdt: _sPz.udtAll,
  })

  const _ls = [
    {
      tgt: 'エントリー',
      msg1: _gStgz.crt.alyMsg1,
      msg2: _gStgz.crt.S07020111,
      msg3: _gStgz.crt.S07020211,
      clr: 'bl',
      pageName: 'icvI1zD10RzE',
    },
    {
      tgt: '予約',
      msg1: _gStgz.crt.rsvMsg1,
      msg2: _gStgz.crt.S06020111,
      msg3: _gStgz.crt.S06020211,
      clr: 'lm',
      pageName: 'icvI1zD10RzR',
    },
    {
      tgt: '設定',
      msg1: '',
      msg2: _gStgz.crt.S02020111,
      msg3: _gStgz.crt.S02020211,
      clr: 'lt',
      pageName: 'icvI18D10Rz',
    },
  ]

  const _clds = _ls.map((_dz: ht.dz, _idx: ht.n) => {
    return (
      cr.c(BoxC.N, {
        key: _idx,
        boxStlz: 
          cr.d('p') ?
            a('dh/f dw/40 fd/ccc')
          : _idx == 0 ?
            a('dw/f f/n fd/csc pt/2')
          : a('bc/lt9 bs/dt bwt/1 dw/f f/n fd/csc pt/2'),
        oClds: [

          cr.c(BtnC.N, {
            key: -5,
            boxz: {
              boxStlz: a('sc/lt3 f/1'),
            },
          }),

          cr.c(BtnC.N, {
            key: -10,
            lblCz: {
              textz: {
                pfx: _dz.msg1,
                stlz: a('ta/c tb tc/rd5 ts/l'),
                ptyz: a('tn/10'),
              },
            },
            boxStlz: a('sc/lt1 f/1 dw/f fd/ccc mb/2')
          }),

          cr.c(BtnC.N, {
            key: -20,
            boxStlz: 
              cr.d('p') ?
                a(`sc/${_dz.clr}5 dh/20 dw/20 br/2 fd/ccc mb/4`)
              : a(`sc/${_dz.clr}5 dh/8 dw/30 br/2 fd/ccc mb/2`),
            lblCz: {
              textz: {
                pfx: _dz.tgt,
                stlz: a('tb tc/lt1 ts/xl'),
                ptyz: a('tn/10'),
              },
            },
            pslPtyz: {
              onPress: () => { // ホーム画面では施設ごとにエントリー期間を設定できないことに注意
                cr.moveTo({
                  pageName: _dz.pageName,
                });
              },
            },
          }),

          cr.c(BtnC.N, {
            key: -30,
            lblCz: {
              textz: {
                pfx: _dz.msg2,
                stlz: a('tb ta/c'),
                ptyz: a('tn/2'),
              },
            },
            boxStlz: 
              cr.d('p') ?
                a('sc/lt1 dh/8 dw/f fd/csc mb/1')
              : a('sc/lt1 dh/3 dw/f f/n fd/csc mb/1'),
          }),

          cr.c(BtnC.N, {
            key: -40,
            lblCz: {
              textz: {
                pfx: _dz.msg3,
                stlz: a('ts/s ta/c'),
                ptyz: a('tn/10'),
              },
            },
            boxStlz: 
              cr.d('p') ?
                a('sc/lt1 dh/10 dw/f fd/csc mb/2')
              : a('sc/lt1 dh/10 dw/f f/n fd/csc mb/2'),
          }),

          cr.c(BtnC.N, {
            key: -50,
            boxz: {
              boxStlz: a('sc/lt3 f/1'),
            },
          }),

        ],
      })
    )
  });

  return (
    cr.c(icvBaseD10Rz.N, {
      key: -10,
      sPz: _sPz,
      cz: {
        bHome: false,
      },
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
          boxStlz: a('dh/f dw/f fd/css'),
          oClds: [

            cr.c(BoxC.N, {
              key: -20,
              boxStlz: 
                cr.d('p') ?
                  a('dw/f f/1 fd/rac fw pt/15')
                : a('dw/f f/n fd/csc'),
              oClds: _clds,
            }),

          ]
        })

      ],
    })
  );
};
